function initAccordions() {
  const accordions = document.querySelectorAll<HTMLElement>(".accordion");

  if (accordions.length < 1) return;

  const hash = window.location.hash;
  const child = hash && document.querySelector<HTMLElement>(hash);

  function openChildAccordion(child: HTMLElement | null) {
    if(child) {
      if (!child) return;
      const accordionsToOpen = [child];

      let current = child;
      
      while (current) {
        const parentAccordion = current?.parentElement?.closest(`.accordion`) as HTMLElement | null;
        current = parentAccordion;
        if(!current) break;
        accordionsToOpen.push(current);
      }

      // for each parent accordion, open the accordion
      accordionsToOpen.reverse().forEach((accordion) => {
        const button = accordion?.querySelector(".accordion-toggle") as HTMLButtonElement;
        const accordionBody = accordion?.querySelector(".accordion-body-content") as HTMLElement;
        accordionBody?.removeAttribute("hidden");
        accordion?.classList.add("accordion--open");
        button?.setAttribute("aria-expanded", "true");
      });

      setTimeout(() => {
        const accordionLocation = child?.closest('.accordion').getBoundingClientRect().top + window.scrollY;
        window.scrollTo({top: accordionLocation, behavior: "smooth"});
      }, 500);
    }
  }

  openChildAccordion(child);

  // for accordion links that are on the same page, make sure to open and navigate properly
  if(window.location.pathname === "/5-elements/") {
    const accordionLinks = document.querySelectorAll<HTMLElement>('a[href*="#accordion-"]');
    accordionLinks.forEach((link) => {
      link.addEventListener("click", function(event) {
        event.preventDefault();
        const target = event.target as HTMLElement;
        const href = target.getAttribute("href");
        const accordionId = href?.includes('#') ? href.slice(href.indexOf('#')) : null;
        const child = document.querySelector<HTMLElement>(accordionId);
        openChildAccordion(child);
      });
    });
  }


  accordions.forEach((accordion) => {
    const button = accordion.querySelector(".accordion-toggle") as HTMLButtonElement;
    button && button.addEventListener("click", handleAccordionClick);
    const accordionBody = accordion.querySelector(".accordion-body") as HTMLElement;
    accordionBody && accordionBody.addEventListener("transitionend", handleTransitionEnd);
  });
}

// Only add the hidden attribute to the accordion body content after accordion has transitioned
function handleTransitionEnd(event: TransitionEvent) {
  const target = event.target as HTMLElement;
  const accordionId = target.getAttribute("id");
  const prefix = target.classList.contains("glossary-accordion-toggle")
    ? "glossary-"
    : "accordion-";
  const accordion = document.getElementById(`${prefix}${accordionId}`);
  const accordionBodyContent = accordion?.querySelector(".accordion-body-content");
  const accordionIsClosing = !accordion?.classList.contains("accordion--open");

  if (accordionBodyContent && accordionIsClosing) {
    accordionBodyContent.setAttribute("hidden", "");
  }
}

function handleAccordionClick(event: MouseEvent) {
  const target = event.target as HTMLElement;
  const button = target.closest('.accordion-toggle') as HTMLButtonElement;
  const accordionId = button.getAttribute("aria-controls");
  const prefix = target.classList.contains("glossary-accordion-toggle")
    ? "glossary-"
    : "accordion-";
  const accordion = target.closest(`#${prefix}${accordionId}`);
  const accordionBody = accordion?.querySelector(".accordion-body-content");
  const accordionIsOpen = button.getAttribute("aria-expanded") === "true";

  if (accordionIsOpen) {
    accordion?.classList.remove("accordion--open");
  } else {
    accordionBody?.removeAttribute("hidden");
    accordion?.classList.add("accordion--open");
  }
  button.setAttribute("aria-expanded", accordionIsOpen ? "false" : "true");

  const isGlossaryAccordion = accordion?.classList.contains("glossary-accordion");
  if (isGlossaryAccordion) {
    const glossaryAccordionToggle = accordion?.querySelector(".glossary-accordion-toggle");
    if (glossaryAccordionToggle) {
      glossaryAccordionToggle.textContent = accordionIsOpen ? "+ Read more" : "- Read less";
    }
  }
}

initAccordions();
